import { Controller } from "@hotwired/stimulus"
import { useSelect2 } from "../mixins/use_select2";

export default class extends Controller {
  connect() {
    const url = this.element.dataset.select2AjaxUrl;
    const match = url.match(/\/autocomplete\/([^/]+)/);
    const model = match ? match[1] : null;

    const params = JSON.parse(this.element.dataset.params || '{}');
    const flexField = params.field;

    useSelect2(this, {
      processResults: function(data, _params) {
        if (!Array.isArray(data[model])) {
          // Prevent errors by returning an empty array
          return { results: [] };
        }
        return {
          results: data[model].map(({ flex_attributes = {}, ...lineItem }) => {
            return {
              ...lineItem,
              text: flex_attributes[flexField] || "Unknown",
            };
          })
        };
      }
    });

    this.setupSelect2()
      .on("change.select2", () => {
        this.dispatch("change");
        this.dispatch("stimulus:change");
      })
      .on("select2:clear", () => {
        this.dispatch("clear");
      })
      .on("select2:select", (event) => {
        const selectedData = event.params.data;
        if (selectedData && selectedData.booking_id) {
          // Dispatch custom data for STT/STC. Check the file
          // set_booking_from_shipment_number_controller.js
          this.dispatch("select", { detail: { bookingId: selectedData.booking_id } });
        } else {
          console.warn("No booking_id found in selected data:", selectedData);
        }
      })
      .on("select2:open", () => {
        document.querySelector(".select2-container--open .select2-search__field").focus();
      });

    this.dispatch("init");
  }
}
